/* eslint-disable react/prop-types */
import React, { useState } from "react"; // React Stuff
import Moment from "react-moment";
import axios from "axios";
import { Col, Row, Form, Button } from "react-bootstrap";
import DateTimePicker from "react-datetime-picker";
import { MdDeleteForever } from "react-icons/md";

const BlockUpdate = (props) => {
  const classid = props.data._id;
  //Manage States
  const [selectedClassType, setSelectedClassType] = useState("");
  const [MaxLearners, setMaxLearners] = useState(props.data.MaxLearners);
  const [Price, setPrice] = useState(props.data.Price);
  const [EndDate, setEndDate] = useState(props.data.EndDate);
  // Toggle Proration
  const toggleProration = async (e) => {
    e.preventDefault();
    props.setSubmitClicked(true);
    let Prorate;
    if (props.data.Prorate) {
      Prorate = false;
    } else {
      Prorate = true;
    }
    const prorateToggle = await axios.put(
      `/api/admin/edit_class/toggle_proration/block`,
      {
        _id: classid,
        Prorate,
      },
      {
        withCredentials: true,
      }
    );
    if (prorateToggle.status === 200) {
      props.setSubmitClicked(false);
      props.setSuccessMessage("Successfully toggled.");
      return props.fetchNewData();
    } else {
      props.setSubmitClicked(false);
      return props.setErrorMessage("There was a problem with your request.");
    }
  };

  // Toggle Visibility
  const toggleVisibility = async (e) => {
    e.preventDefault();
    props.setSubmitClicked(true);
    let isHiddenFromSchedule;
    if (props.data.isHiddenFromSchedule === "public") {
      isHiddenFromSchedule = "hidden";
    } else {
      isHiddenFromSchedule = "public";
    }
    const visibilityToggle = await axios.put(
      `/api/admin/edit_class/toggle_visibility/block`,
      {
        _id: classid,
        isHiddenFromSchedule,
      },
      {
        withCredentials: true,
      }
    );
    if (visibilityToggle.status === 200) {
      props.setSubmitClicked(false);
      props.setSuccessMessage("Successfully toggled.");
      return props.fetchNewData();
    } else {
      props.setSubmitClicked(false);
      return props.setErrorMessage("There was a problem with your request.");
    }
  };

  // Change End Date
  const handleEndDateChange = async (e) => {
    e.preventDefault();
    props.setSubmitClicked(true);
    const requestEndDateChange = await axios.put(
      `/api/admin/edit_class/end_date/`,
      { classid, EndDate },
      {
        withCredentials: true,
      }
    );
    if (requestEndDateChange.status === 200) {
      props.setSubmitClicked(false);
      props.setSuccessMessage("Successfully changed end date.");
      return props.fetchNewData();
    } else {
      props.setSubmitClicked(false);
      return props.setErrorMessage("There was a problem with your request.");
    }
  };

  // Change Class Type
  const changeClassType = async (e) => {
    e.preventDefault();
    props.setSubmitClicked(true);
    // Get the relevant class data to submit
    const fetchClassType = props.classTypes.find( types => {
      return types._id === selectedClassType;
    })
    // Construct the data Packet
    const data = {
      classid,
      LessonType: fetchClassType.Type,
      ShortDescription: fetchClassType.ShortDescription,
      LowerAgeString: fetchClassType.LowerAgeString,
      UpperAgeString: fetchClassType.UpperAgeString,
      GradingList: fetchClassType.GradingList,
    };
    // Set the new Class Data
    const setNewClassType = await axios.put(`/api/admin/edit_class/class_type/block`, data, {
      withCredentials: true,
    });
    // handle the response
    if (setNewClassType.status === 200) {
      props.setSubmitClicked(false);
      props.setSuccessMessage("Successfully changed class type.");
      return props.fetchNewData();
    } else {
      props.setSubmitClicked(false);
      return props.setErrorMessage("There was a problem with your request.");
    }
  };

  // Change Capacity
  const handleCapacityChange = async (e) => {
    e.preventDefault();
    props.setSubmitClicked(true);
    const requestMaxLearnerChange = await axios.put(
      `/api/admin/edit_class/capacity/block`,
      { classid, MaxLearners },
      {
        withCredentials: true,
      }
    );
    if (requestMaxLearnerChange.status === 200) {
      props.setSubmitClicked(false);
      props.setSuccessMessage("Successfully changed class capacity.");
      return props.fetchNewData();
    } else {
      props.setSubmitClicked(false);
      return props.setErrorMessage("There was a problem with your request.");
    }
  };

  // Change Start Date
  const handlePriceChange = async (e) => {
    e.preventDefault();
    const data = {
      classid,
      newPrice: Price,
    };
    const requestPriceChange = await axios.put(
      `/api/admin/manage_prices/update_block_price/`,
      data,
      {
        withCredentials: true,
      }
    );
    if (requestPriceChange.status === 200) {
      props.setSubmitClicked(false);
      props.setSuccessMessage("Successfully updated class price.");
      return props.fetchNewData();
    } else {
      props.setSubmitClicked(false);
      return props.setErrorMessage("There was a problem with your request.");
    }
  };

  return (
    <>
      <Row className='border mt-4 text-center'>
        <Col className='mt-2 mb-2'>
          <h2>Edit Class Details</h2>
          <span className='mt-2'>
            You can edit your class details here. Editing class details will not inform participants
            of changes.
          </span>
        </Col>
      </Row>
      <Row className='mt-2 text-center'>
        <Col lg='6'>
          <Form onSubmit={toggleProration} className='mt-2 mb-2 border p-3 shadow'>
            <Form.Group controlId='CapacityForm'>
              <Form.Label className='d-block'>Toggle Proration</Form.Label>
              <Form.Text className='text-muted'>
                <small>
                  For Block style classes, proration behaviour determines if Signaclass adjusts the
                  payment to remove lessons that have already passed from the blocks dates. If you
                  want your customers to only pay for dates that haven&apos;t happened, this should
                  be on.
                </small>
              </Form.Text>
            </Form.Group>
            {props.data.Prorate ? (
              <Button
                variant='danger'
                className=' mt-3 mb-4'
                type='submit'
                onClick={props.scrollSmoothHandler}
                disabled={props.submitClicked}
              >
                Disable Proration
              </Button>
            ) : (
              <Button
                variant='primary'
                className='mt-3 mb-4'
                type='submit'
                onClick={props.scrollSmoothHandler}
                disabled={props.submitClicked}
              >
                Enable Proration
              </Button>
            )}
          </Form>
        </Col>

        <Col lg='6'>
          <Form className='mt-2 mb-2 border p-3 shadow' onSubmit={toggleVisibility}>
            <Form.Group controlId='CapacityForm'>
              <Form.Label className='d-block'>Toggle Visibility</Form.Label>
              <Form.Text className='text-muted'>
                <small>
                  Toggling class visibility allows you to remove a session from the public timetable
                  but keep it active. It might be useful if you no longer want to advertise a class
                  or want to offer private classes. Class Signup and checkout links still work.
                </small>
              </Form.Text>
            </Form.Group>
            {props.data.isHiddenFromSchedule === "public" ? (
              <Button
                variant='danger'
                className=' mt-3 mb-4'
                type='submit'
                onClick={props.scrollSmoothHandler}
                disabled={props.submitClicked}
              >
                Hide Class
              </Button>
            ) : (
              <Button
                variant='primary'
                className='mt-3 mb-4'
                type='submit'
                onClick={props.scrollSmoothHandler}
                disabled={props.submitClicked}
              >
                Unhide Class
              </Button>
            )}
          </Form>
        </Col>
      </Row>
      <Row className='mt-4 text-center'>
        <Col lg='6'>
          <Form className='mt-2 mb-2 border p-3 shadow' onSubmit={changeClassType}>
            <Form.Group controlId='selectClassType'>
              <Form.Label>Change Class Type</Form.Label>
              <Form.Control
                as='select'
                value={selectedClassType}
                onChange={(e) => setSelectedClassType(e.target.value)}
                required
                custom
              >
                <option value='' disabled defaultValue>
                  Select your option
                </option>
                {props.classTypes.map((ClassType) => (
                  <option key={ClassType._id} value={ClassType._id}>
                    {ClassType.Type}
                  </option>
                ))}
              </Form.Control>
              <Form.Text className='text-muted'>The type of lesson this is.</Form.Text>
            </Form.Group>
            <Button
              variant='primary'
              className='mt-3 mb-4'
              type='submit'
              onClick={props.scrollSmoothHandler}
              disabled={props.submitClicked}
            >
              Change
            </Button>
          </Form>
        </Col>
        <Col lg='6'>
          <Form className='mt-2 mb-2 border p-3 shadow' onSubmit={handleCapacityChange}>
            <Form.Group controlId='CapacityForm'>
              <Form.Label>Change Capacity</Form.Label>
              <Form.Control
                type='number'
                min='0'
                max='100'
                value={MaxLearners}
                onChange={(e) => setMaxLearners(e.target.value)}
                required
              />
              <Form.Text className='text-muted'>
                The maximum number of participants for this session.
              </Form.Text>
            </Form.Group>
            <Button
              variant='primary'
              className='mt-3 mb-4'
              type='submit'
              onClick={props.scrollSmoothHandler}
              disabled={props.submitClicked}
            >
              Change
            </Button>
          </Form>
        </Col>
      </Row>
      <Row className='mt-4 mb-4 text-center'>
        <Col sm='6'>
          <Form className='border p-3 shadow' onSubmit={handlePriceChange}>
            <Form.Group controlId='PriceForm'>
              <Form.Label>Price</Form.Label>
              <Form.Control
                type='number'
                min='0'
                max='1000'
                step='0.01'
                placeholder='10.50'
                value={Price}
                onChange={(e) => setPrice(e.target.value)}
                required
              />
              <Form.Text className='text-muted'>
                Setting a new price changes the price on blocks only for people who sign up for
                forward dates. No refund is automatically issued by Signaclass.
              </Form.Text>
            </Form.Group>
            <Button
              variant='primary'
              className='mt-3 mb-4'
              type='submit'
              onClick={props.scrollSmoothHandler}
              disabled={props.submitClicked}
            >
              Change Price
            </Button>
          </Form>
        </Col>
        <Col sm='6'>
          <Form className='border p-3 shadow' onSubmit={handleEndDateChange}>
            <Form.Group controlId='EndDateform'>
              <Form.Label>Change Cut-Off Date</Form.Label>
              <Form.Control
                type='date'
                value={EndDate}
                onChange={(e) => setEndDate(e.target.value)}
                required
              />
              <Form.Text className='text-muted'>
                The cut-off date determines the final day the class shows on the public schedules and
                for bookings to be allowed. Currently:{" "}
                <Moment format='DD MMMM YYYY'>{props.data.EndDate}</Moment>
              </Form.Text>
            </Form.Group>
            <Button
              variant='primary'
              className='mt-3 mb-4'
              type='submit'
              onClick={props.scrollSmoothHandler}
              disabled={props.submitClicked}
            >
              Change Cut-Off
            </Button>
          </Form>
        </Col>
      </Row>
      <ChangeDates
        Dates={props.data.Dates}
        classid={props.data._id}
        scrollSmoothHandler={props.scrollSmoothHandler}
        fetchNewData={props.fetchNewData}
        submitClicked={props.submitClicked}
        setSubmitClicked={props.setSubmitClicked}
        setErrorMessage={props.setErrorMessage}
        setSuccessMessage={props.setSuccessMessage}
      />
    </>
  );
};

const ChangeDates = (props) => {
  const [Dates, setDates] = useState(props.Dates);
  const [displayDate, setDisplayDate] = useState("");
  const [confirm, setConfirm] = useState(false);
  const classid = props.classid;

  const addDate = (e) => {
    e.preventDefault();
    return setDates(Dates.concat(displayDate));
  };

  //Remove a grading criteria
  const removeDate = (e, index) => {
    e.preventDefault();
    const newDateList = [...Dates];
    if (index !== -1) {
      newDateList.splice(index, 1);
      setDates(newDateList);
    }
  };

  const handleDatesChange = async (e) => {
    e.preventDefault();
    props.setSubmitClicked(true);
    const data = {
      classid,
      Dates: Dates,
    };
    const requestDateChange = await axios.put(`/api/admin/edit_class/change_dates/`, data, {
      withCredentials: true,
    });
    if (requestDateChange.status === 200) {
      props.setSubmitClicked(false);
      setConfirm(false);
      props.setSuccessMessage("Successfully updated class dates.");
      return props.fetchNewData();
    } else {
      setConfirm(false);
      props.setSubmitClicked(false);
      return props.setErrorMessage("There was a problem with your request.");
    }
  };

  return (
    <Row>
      <Col className='mt-2'>
        <Form className='border p-3 shadow text-center' onSubmit={handleDatesChange}>
          <hr />
          <h5>Change Dates</h5>
          <p>You can only change dates on blocks that don&apos;t have current activity.</p>
          <div className='pb-2 pt-2'>
            {Dates.map((date, index) => (
              <span
                className='me-2 text-center shadow border p-1 mt-1 d-block d-md-inline-block'
                key={index}
                onClick={(e) => removeDate(e, index)}
              >
                <Moment format='ddd DD MMMM, h:mm A'>{date}</Moment> <MdDeleteForever />
              </span>
            ))}
          </div>
          <DateTimePicker value={displayDate} onChange={(date) => setDisplayDate(date)} />
          <br />
          <Button
            className='mb-3 mt-3'
            variant='primary'
            size='info'
            type='button'
            onClick={(e) => addDate(e)}
          >
            Add Date
          </Button>
          <hr />
          <p>
            We do not advise changing advertised dates after participants have already signed up, but if you wish you can do so here.
          </p>
          {!confirm ? (
            <Button
              variant='primary'
              className='mt-3 mb-4'
              type='button'
              disabled={props.submitClicked}
              onClick={() => setConfirm(true)}
            >
              Change Dates
            </Button>
          ) : (
            <>
              <Button
                variant='danger'
                type='submit'
                disabled={props.submitClicked}
                onClick={props.scrollSmoothHandler}
              >
                Confirm
              </Button>
              <Button
                variant='secondary'
                className='ms-2'
                type='button'
                disabled={props.submitClicked}
                onClick={() => setConfirm(false)}
              >
                Cancel
              </Button>
            </>
          )}
        </Form>
      </Col>
    </Row>
  );
};

export default BlockUpdate;
